// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3sS8Q","info":"Note_info__2XmYA","note":"Note_note__1km1z","actions":"Note_actions__2cvtM"};